// PrivateRoute.tsx in v6
import { useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import IgniteNavBar from "./IgniteNavBar";
import { isLoggedIn, isNhKLocked } from "../reducers/auth";
import { useSelector } from "react-redux";
import IgniteFooter from "./IgniteFooter";
import { getSubsite } from "../reducers/auth";

const NHK_ALLOWLIST = [
  '/newhirekit',
  '/profile',
  '/logout',
];

const AuthRoute = ({ children }) => {
  let navigate = useNavigate();
  const location = useLocation();
  const isLoggedInVal = useSelector(isLoggedIn);
  const currentSubsite = useSelector(getSubsite);
  const nhkLocked = useSelector(isNhKLocked);
  
  useEffect(() => {
    if (!isLoggedInVal) {
      navigate("/home");
      return;
    }
    if (nhkLocked) {
      const path = location.pathname || '';
      const allowed = NHK_ALLOWLIST.some((p) => path === p || path.startsWith(p + '/'));
      if (!allowed) {
        navigate("/newhirekit", { replace: true });
      }
    }
  }, [navigate, isLoggedInVal, nhkLocked, location.pathname]);

  return (
    <>
      <IgniteNavBar />
      {children}
      <IgniteFooter menuBgColor={currentSubsite?.subsite_content?.menuBgColor} />
    </>
  ) 
};

export default AuthRoute;
